import { throttle } from "../utils/performance";
export default function(el) {
    const chaptersNav = el;
    const mainNav = document.querySelector(".nav");
    const chapterLinks = document.querySelectorAll(".subNav-chapters__link");
    const sections = document.querySelectorAll("section");
    const brick = document.getElementById("brick");
    const chapterHeight = 48;

    let lastActiveSection = null;
    let isManualScroll = false;

    const chapterIds = Array.from(chapterLinks)
        .map((link) => link.getAttribute("href")?.slice(1))
        .filter(Boolean);
    let lastBoundaryBottom = 0;

    function assignDataIds() {
        sections.forEach((section, index) => {
            if (section.id) {
                const range = parseInt(section.getAttribute("data-range")) || 0;
                section.setAttribute("data-id", section.id);

                for (let i = 1; i <= range; i++) {
                    const nextSection = sections[index + i];
                    if (!nextSection || nextSection.id) break;
                    nextSection.setAttribute("data-id", section.id);
                }
            }
        });
    }

    function getNavHeights() {
        const mainNavHeight = mainNav?.offsetHeight || 0;
        const breadcrumbs = document.querySelector(".nav__bc");
        const breadcrumbsHeight = breadcrumbs?.offsetHeight || 0;
        const adsBar = document.querySelector(".ads-w--bar");
        const adsBarHeight = adsBar?.offsetHeight || 0;
        return mainNavHeight + breadcrumbsHeight - adsBarHeight;
    }

    function computeLastBoundary() {
        const lastId = chapterIds[chapterIds.length - 1];
        if (!lastId) {
            lastBoundaryBottom = 0;
            return;
        }

        const tracked = Array.from(sections).filter((sec) => sec.getAttribute("data-id") === lastId);
        let lastSection = tracked[tracked.length - 1];

        if (!lastSection) {
            lastSection = document.getElementById(lastId);
        }

        if (lastSection) {
            lastBoundaryBottom = lastSection.offsetTop + lastSection.offsetHeight;
        } else {
            lastBoundaryBottom = 0;
        }
    }

    function updateActiveClass() {
        if (isManualScroll) return;

        const navHeights = getNavHeights();
        const scrollPosition = window.scrollY + navHeights + (chapterHeight + 10);
        let newActiveSection = null;

        sections.forEach((section) => {
            const sectionId = section.getAttribute("data-id");
            if (!sectionId) return;

            const sectionTop = section.offsetTop;
            const sectionBottom = sectionTop + section.offsetHeight;
            if (scrollPosition >= sectionTop && scrollPosition < sectionBottom) {
                newActiveSection = sectionId;
            }
        });

        if (!newActiveSection) {
            updateNavHighlight(null);
            lastActiveSection = null;
            return;
        }

        if (newActiveSection !== lastActiveSection) {
            lastActiveSection = newActiveSection;
            updateNavHighlight(newActiveSection);
        }
    }

    function updateNavHighlight(activeSection) {
        chapterLinks.forEach((link) => {
            const parentLi = link.closest("li");
            if (activeSection && link.getAttribute("href").slice(1) === activeSection) {
                parentLi?.classList.add("active");
            } else {
                parentLi?.classList.remove("active");
            }
        });
    }

    function checkBrickPosition() {
        const totalNavHeight = getNavHeights();
        const subNav = document.querySelector(".subNav-chapters");

        if (!mainNav || !subNav || !brick) return;

        const brickSection = brick.closest("section");
        const nextSection = brickSection?.nextElementSibling;

        const subNavOriginalTop = brick.offsetTop;
        const scrollPosition = window.scrollY;
        const nextSectionTop = nextSection?.offsetTop || 0;

        const chapterNavOffset = 15;
        if (scrollPosition + totalNavHeight + chapterNavOffset < subNavOriginalTop) {
            subNav.style.position = "absolute";
            subNav.style.left = "auto";
            subNav.style.top = `${nextSectionTop - chapterHeight}px`;
        } else {
            subNav.style.position = "fixed";
            subNav.style.left = "auto";
            subNav.style.marginTop = "0";

            if (!lastBoundaryBottom) computeLastBoundary();
            const scrollEdge = scrollPosition + totalNavHeight;
            const isOutsideChapterContent = lastBoundaryBottom > 0 && scrollEdge + chapterHeight >= lastBoundaryBottom;

            if (isOutsideChapterContent) {
                subNav.style.top = `${totalNavHeight - 5}px`;
            } else {
                subNav.style.top = `${totalNavHeight + chapterNavOffset}px`;
            }
        }
    }

    function updateSubNavVisibility() {
        const subNav = document.querySelector(".subNav-chapters");
        if (!subNav) return;

        if (!lastBoundaryBottom) computeLastBoundary();

        const navHeights = getNavHeights();
        const scrollPosition = window.scrollY + navHeights;
        const shouldHide = lastBoundaryBottom > 0 && scrollPosition + chapterHeight >= lastBoundaryBottom;

        subNav.style.transition = "transform 200ms ease";
        subNav.style.transform = shouldHide ? "translateY(-100%)" : "translateY(0)";
    }

    function onScrollEnd() {
        isManualScroll = false;
        updateActiveClass();
        updateSubNavVisibility();
    }

    const debouncedScrollEnd = (() => {
        let timer;
        return function() {
            if (timer) clearTimeout(timer);
            timer = setTimeout(onScrollEnd, 100);
        };
    })();

    chapterLinks.forEach((link) => {
        link.addEventListener("click", (event) => {
            event.preventDefault();

            const targetId = link.getAttribute("href").slice(1);
            const targetSection = document.getElementById(targetId);

            if (targetSection) {
                lastActiveSection = targetId;
                updateNavHighlight(targetId);
                isManualScroll = true;

                const targetPosition = targetSection.offsetTop - getNavHeights() - chapterHeight - 15;

                window.scrollTo({
                    top: targetPosition,
                    behavior: "smooth",
                });

                window.addEventListener("scroll", debouncedScrollEnd, { passive: true });
            }
        });
    });

    if (brick) brick.style.height = "15px";

    assignDataIds();
    computeLastBoundary();

    window.addEventListener("scroll", throttle(checkBrickPosition, 100));
    window.addEventListener("scroll", throttle(updateActiveClass, 100));
    window.addEventListener("scroll", throttle(updateSubNavVisibility, 100));

    if (document.readyState === "loading") {
        document.addEventListener("DOMContentLoaded", () => {
            checkBrickPosition();
            updateActiveClass();
            updateSubNavVisibility();
        });
    } else {
        checkBrickPosition();
        updateActiveClass();
        updateSubNavVisibility();
    }

    window.addEventListener("load", () => {
        checkBrickPosition();
        updateActiveClass();
        updateSubNavVisibility();
    });

    setTimeout(() => {
        checkBrickPosition();
        updateActiveClass();
        updateSubNavVisibility();
    }, 200);

    if (typeof ResizeObserver === "function") {
        const resizeObserver = new ResizeObserver(
            throttle(() => {
                computeLastBoundary();
                checkBrickPosition();
                updateActiveClass();
                updateSubNavVisibility();
            }, 100)
        );

        if (brick) resizeObserver.observe(brick);
        const mainContent = document.querySelector("main") || document.body;
        resizeObserver.observe(mainContent);
    }
}
